<template>
  <l-map
    ref="map"
    style="position: relative; font-size:18px; height:900px; width: 100%; background-color:rgba(0, 0, 0, 0); color:#ffffff; z-index: 0;"
    :crs="crs"
    :min-zoom="minZoom4"
    :zoom="-1"
    :options="{scrollWheelZoom:false, zoomControl: false, doubleClickZoom: false, attributionControl:false,
               touchZoom: false, tap: false, dragging: false}"
  >
    <l-image-overlay
      :url="require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/Dai-cb2-mc1.png')"
      :bounds="bounds4"
    />
    <!-- STW ----------------------------------------------------------->
    <l-marker
      v-if="items.c_safety_swtich === '0' && items.c_safety_swtich_phase2 === '0' && items.c_safety_swtich_phase3 === '0'"
      :lat-lng="[350, 88]"
      :icon="iconST000"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_safety_switch }}
      </l-popup>
    </l-marker>
    <l-marker
      v-if="items.c_safety_swtich === '1' && items.c_safety_swtich_phase2 === '0' && items.c_safety_swtich_phase3 === '0'"
      :lat-lng="[350, 88]"
      :icon="iconST100"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_safety_switch }}
      </l-popup>
    </l-marker>
    <l-marker
      v-if="items.c_safety_swtich === '0' && items.c_safety_swtich_phase2 === '1' && items.c_safety_swtich_phase3 === '0'"
      :lat-lng="[350, 88]"
      :icon="iconST010"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_safety_switch }}
      </l-popup>
    </l-marker>
    <l-marker
      v-if="items.c_safety_swtich === '0' && items.c_safety_swtich_phase2 === '0' && items.c_safety_swtich_phase3 === '1'"
      :lat-lng="[350, 88]"
      :icon="iconST001"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_safety_switch }}
      </l-popup>
    </l-marker>
    <l-marker
      v-if="items.c_safety_swtich === '1' && items.c_safety_swtich_phase2 === '1' && items.c_safety_swtich_phase3 === '0'"
      :lat-lng="[350, 88]"
      :icon="iconST110"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_safety_switch }}
      </l-popup>
    </l-marker>
    <l-marker
      v-if="items.c_safety_swtich === '0' && items.c_safety_swtich_phase2 === '1' && items.c_safety_swtich_phase3 === '1'"
      :lat-lng="[350, 88]"
      :icon="iconST011"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_safety_switch }}
      </l-popup>
    </l-marker>
    <l-marker
      v-if="items.c_safety_swtich === '1' && items.c_safety_swtich_phase2 === '0' && items.c_safety_swtich_phase3 === '1'"
      :lat-lng="[350, 88]"
      :icon="iconST101"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_safety_switch }}
      </l-popup>
    </l-marker>
    <l-marker
      v-if="items.c_safety_swtich === '1' && items.c_safety_swtich_phase2 === '1' && items.c_safety_swtich_phase3 === '1'"
      :lat-lng="[350, 88]"
      :icon="iconST111"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_safety_switch }}
      </l-popup>
    </l-marker>

    <!-- MCB ----------------------------------------------------------->
    <l-marker
      v-if="(items.c_safety_swtich === '0' && items.c_safety_swtich_phase2 === '0' && items.c_safety_swtich_phase3 === '0') ||
        (items.c_main_breaker === '0' && items.c_main_breaker_phase2 === '0' && items.c_main_breaker_phase3 === '0')"
      :lat-lng="[54, -78]"
      :icon="iconMCBFF"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_main_breaker }}
      </l-popup>
    </l-marker>
    <l-marker
      v-else-if="(items.c_safety_swtich === '1' && items.c_safety_swtich_phase2 === '1' && items.c_safety_swtich_phase3 === '1') ||
        (items.c_main_breaker === '1' && items.c_main_breaker_phase2 === '1' && items.c_main_breaker_phase3 === '1')"
      :lat-lng="[54, -78]"
      :icon="iconMCBNN"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_main_breaker }}
      </l-popup>
    </l-marker>
    <l-marker
      v-else
      :lat-lng="[54, -78]"
      :icon="iconMCBNF"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_main_breaker }}
      </l-popup>
    </l-marker>
    <!-- photo swicth ----------------------------------------------------------->
    <l-marker
      v-if="items.c_photo_switch === '0'"
      :lat-lng="[-68, -130]"
      :icon="iconPhoto4"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_photo_switch }}
      </l-popup>
    </l-marker>
    <l-marker
      v-else
      :lat-lng="[-68, -130]"
      :icon="iconPhotoMoon"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_photo_switch }}
      </l-popup>
    </l-marker>
    <!-- CB1 L1 ----------------------------------------------------------->
    <l-marker
      v-if="(items.c_safety_swtich === '1' && items.c_safety_swtich_phase2 === '1' && items.c_safety_swtich_phase3 === '1')
        || (items.c_main_breaker === '1' && items.c_main_breaker_phase2 === '1' && items.c_main_breaker_phase3 === '1')
        && (items.c_sub_breaker1 === '1' && items.c_sub_breaker1_phase2 === '1' && items.c_sub_breaker1_phase3 === '1')"
      :lat-lng="[-245, -90]"
      :icon="iconCB1N"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_sub_breaker1 }}
      </l-popup>
    </l-marker>
    <l-marker
      v-else-if="(items.c_safety_swtich === '0' && items.c_safety_swtich_phase2 === '0' && items.c_safety_swtich_phase3 === '0')
        || (items.c_main_breaker === '0' && items.c_main_breaker_phase2 === '0' && items.c_main_breaker_phase3 === '0')
        && (items.c_sub_breaker1 === '0' && items.c_sub_breaker1_phase2 === '0' && items.c_sub_breaker1_phase3 === '0')"
      :lat-lng="[-245, -90]"
      :icon="iconCBF"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_sub_breaker1 }}
      </l-popup>
    </l-marker>
    <l-marker
      v-else
      :icon="iconCB1NF"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_sub_breaker1 }}
      </l-popup>
    </l-marker>
    <!-- CB2 ----------------------------------------------------------->
    <l-marker
      v-if="(items.c_safety_swtich === '1' && items.c_safety_swtich_phase2 === '1' && items.c_safety_swtich_phase3 === '1')
        || (items.c_main_breaker === '1' && items.c_main_breaker_phase2 === '1' && items.c_main_breaker_phase3 === '1')
        && (items.c_sub_breaker2 === '1' && items.c_sub_breaker2_phase2 === '1' && items.c_sub_breaker2_phase3 === '1')"
      :lat-lng="[-245, -90]"
      :icon="iconCB2N"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_sub_breaker1 }}
      </l-popup>
    </l-marker>
    <l-marker
      v-else-if="(items.c_safety_swtich === '0' && items.c_safety_swtich_phase2 === '0' && items.c_safety_swtich_phase3 === '0')
        || (items.c_main_breaker === '0' && items.c_main_breaker_phase2 === '0' && items.c_main_breaker_phase3 === '0')
        && (items.c_sub_breaker2 === '0' && items.c_sub_breaker2_phase2 === '0' && items.c_sub_breaker2_phase3 === '0')"
      :lat-lng="[-245, -90]"
      :icon="iconCB2F"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_sub_breaker1 }}
      </l-popup>
    </l-marker>
    <l-marker
      v-else
      :lat-lng="[-245, -90]"
      :icon="iconCB2NF"
    >
      <l-popup style="color:#ffffff; width: 2000px; font-size: 14px;">
        {{ items.value_sub_breaker1 }}
      </l-popup>
    </l-marker>

    <!-- MC ----------------------------------------------------------->
    <l-marker
      v-if="((items.c_magnetic_contactor1 === '1' && items.c_sub_breaker1 === '1') && (items.c_magnetic_contactor1 === '1' && items.c_sub_breaker2 === '1'))
        && (items.line_detect1 === 1 || items.line_detect2 === 1) && (items.line_detect3 === 1 || items.line_detect4 === 1)"
      :lat-lng="[-422, -350]"
      :icon="iconMCNN"
    />
    <l-marker
      v-else-if="((items.c_magnetic_contactor1 === '0' || items.c_sub_breaker1 === '0') && (items.c_magnetic_contactor1 === '0' || items.c_sub_breaker2 === '0'))
        && (items.line_detect1 === 1 || items.line_detect2 === 1) && (items.line_detect3 === 1 || items.line_detect4 === 1)"
      :lat-lng="[-422, -350]"
      :icon="iconMCFF"
    />
    <l-marker
      v-else-if="(items.line_detect1 === 0 && items.line_detect2 === 0) && (items.line_detect3 === 0 && items.line_detect4 === 0)"
      :lat-lng="[-422, -350]"
      :icon="iconMCBB"
    />
    <l-marker
      v-else-if="(items.c_magnetic_contactor1 === '0' || items.c_sub_breaker2 === '0') && (items.line_detect1 === 0 && items.line_detect2 === 0) && (items.line_detect3 === 1 || items.line_detect4 === 1)"
      :lat-lng="[-422, -350]"
      :icon="iconMCBF"
    />
    <l-marker
      v-else-if="(items.c_magnetic_contactor1 === '0' || items.c_sub_breaker1 === '0') && (items.line_detect3 === 0 && items.line_detect4 === 0) && (items.line_detect1 === 1 || items.line_detect2 === 1)"
      :lat-lng="[-422, -350]"
      :icon="iconMCFB"
    />
    <l-marker
      v-else-if="(items.c_magnetic_contactor1 === '1' || items.c_sub_breaker2 === '1') && (items.line_detect1 === 0 && items.line_detect2 === 0) && (items.line_detect3 === 1 || items.line_detect4 === 1)"
      :lat-lng="[-422, -350]"
      :icon="iconMCBN"
    />
    <l-marker
      v-else-if="(items.c_magnetic_contactor1 === '1' || items.c_sub_breaker1 === '1') && (items.line_detect3 === 0 && items.line_detect4 === 0) && (items.line_detect1 === 1 || items.line_detect2 === 1)"
      :lat-lng="[-422, -350]"
      :icon="iconMCNB"
    />
    <l-marker
      v-else-if="((items.c_magnetic_contactor1 === '1' || items.c_sub_breaker1 === '0') || (items.c_magnetic_contactor1 === '1' || items.c_sub_breaker2 === '0'))
        && (items.line_detect1 === 1 || items.line_detect2 === 1) && (items.line_detect3 === 1 || items.line_detect4 === 1)"
      :lat-lng="[-422, -350]"
      :icon="iconMCNF"
    />
  </l-map>
</template>

<script>
/* eslint-disable global-require */
import {
  LMap, LImageOverlay,
  LMarker, LPopup,
  // LIcon,
} from 'vue2-leaflet'
import { CRS, icon, Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPopup,
    // LIcon,
  },
  data() {
    return {
      waydetail: '',
      checkLeft1: '',
      checkRight1: '',
      checkLeft2: '',
      checkRight2: '',
      bounds4: [[-900, 950], [950, -700]],
      iconSize: 64,
      crs: CRS.Simple,
      minZoom4: -1,
      deptid: '',
      items: [],

      // safety_swtich
      iconST000: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB-67/st-cb6-1-000.gif'),
        iconSize: [362, 322],
      }),
      iconST100: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB-67/st-cb6-1-100.gif'),
        iconSize: [140, 270],
      }),
      iconST010: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB-67/st-cb6-1-010.gif'),
        iconSize: [140, 270],
      }),
      iconST001: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB-67/st-cb6-1-001.gif'),
        iconSize: [140, 270],
      }),
      iconST110: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB-67/st-cb6-1-110.gif'),
        iconSize: [140, 270],
      }),
      iconST011: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB-67/st-cb6-1-011.gif'),
        iconSize: [140, 270],
      }),
      iconST101: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB-67/st-cb6-1-101.gif'),
        iconSize: [140, 270],
      }),
      iconST111: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB-67/st-cb6-1-111.gif'),
        iconSize: [140, 270],
      }),
      iconPhoto4: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB/Photo-DR.gif'),
        iconSize: [220, 179],
      }),
      iconPhotoMoon: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2MC-2CB/Photo-N.gif'),
        iconSize: [220, 179],
      }),
      iconMCBNN: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/mcb-n1.gif'),
        iconSize: [230, 200],
        iconAnchor: [16, 37],
      }),
      iconMCBFF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/mcb-r1.gif'),
        iconSize: [230, 200],
        iconAnchor: [16, 37],
      }),
      iconMCBNF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/mcb-yr1.gif'),
        iconSize: [230, 200],
        iconAnchor: [16, 37],
      }),
      iconCB2N: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/cbr1.gif'),
        iconSize: [226, 198],
        iconAnchor: [16, 37],
      }),
      iconCB2F: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/cbrr1.gif'),
        iconSize: [226, 198],
        iconAnchor: [16, 37],
      }),
      iconCB2NF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/cbry1.gif'),
        iconSize: [226, 198],
        iconAnchor: [16, 37],
      }),
      iconCB1N: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/cbl1.gif'),
        iconSize: [226, 198],
        iconAnchor: [16, 37],
      }),
      iconCB1F: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/cblr1.gif'),
        iconSize: [226, 198],
        iconAnchor: [16, 37],
      }),
      iconCB1NF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/cbly1.gif'),
        iconSize: [226, 198],
        iconAnchor: [16, 37],
      }),
      iconMCNN: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/mc-lr-n1.gif'),
        iconSize: [483, 263],
        iconAnchor: [16, 37],
      }),
      iconMCFF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/mc-lr-r1.gif'),
        iconSize: [483, 263],
        iconAnchor: [16, 37],
      }),
      iconMCNF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/mc-lr-rn1.gif'),
        iconSize: [483, 263],
        iconAnchor: [16, 37],
      }),
      iconMCBB: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/cb-lr-rr1.gif'),
        iconSize: [483, 263],
        iconAnchor: [16, 37],
      }),
      iconMCFB: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/mc-lr-l1-b1.gif'),
        iconSize: [483, 263],
        iconAnchor: [16, 37],
      }),
      iconMCBF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/mc-lr-r1-b1.gif'),
        iconSize: [483, 263],
        iconAnchor: [16, 37],
      }),
      iconMCBN: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/nrn1-b1.gif'),
        iconSize: [483, 263],
        iconAnchor: [16, 37],
      }),
      iconMCNB: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/3STW-3MCB-1PW-2CB-1MC-67/nln1-b1.gif'),
        iconSize: [483, 263],
        iconAnchor: [16, 37],
      }),
      sem_type: '',
      diagram_type: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    // this.checkLine()
    this.getCenterSem()
    this.getValueDiagram()
    this.interval = setInterval(() => {
      this.getValueDiagram()
      this.getCenterSem()
      // this.checkLine()
    }, 10000)
  },
  mounted() {
    this.$refs.map.mapObject.invalidateSize()
  },
  methods: {
    // checkLine() {
    //   axios.post('/checkLine', { wid: this.$route.query.wid })
    //     .then(response => {
    //       // eslint-disable-next-line prefer-destructuring
    //       this.check = response.data[0]
    //       if (this.check.line_detect1 === 'OK') {
    //         this.checkLeft1 = true
    //       } else {
    //         this.checkLeft1 = false
    //       }
    //       if (this.check.line_detect2 === 'OK') {
    //         this.checkLeft2 = true
    //       } else {
    //         this.checkLeft2 = false
    //       }
    //       if (this.check.line_detect3 === 'OK') {
    //         this.checkRight1 = true
    //       } else {
    //         this.checkRight1 = false
    //       }
    //       if (this.check.line_detect4 === 'OK') {
    //         this.checkRight2 = true
    //       } else {
    //         this.checkRight2 = false
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    getCenterSem() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
          this.switch.semid = response.data[0].id
        })
        .catch(error => {
          console.log(error)
        })
    },
    getValueDiagram() {
      axios
        .post('/getDiagram3P', { wid: this.$route.query.wid })
        .then(response => {
          this.sem_type = response.data[0].firmware
          this.diagram_type = response.data[0].diagram_type
          // eslint-disable-next-line prefer-destructuring
          this.items = response.data[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
<style  lang="scss" scoped>
.headline {
  font-size: 20px;
}
.title {
  color:#FFFFD5
}
.nowrap {
  white-space: nowrap ;
}
</style>
